import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4A5568",
      "fill-rule": "evenodd",
      d: "M15.657 15.657A8 8 0 1 1 4.343 4.342a8 8 0 0 1 11.314 11.315m-6.886-8.8h2.784q.434 0 .656-.187a.61.61 0 0 0 .223-.492q0-.698-.914-.698H8.426q-.504 0-.727.229-.223.228-.304.732l-.493 2.807a7 7 0 0 0-.064.398.64.64 0 0 0 .223.475.73.73 0 0 0 .51.205q.263 0 .667-.305.411-.31.627-.433t.72-.123q.41 0 .745.2.334.192.533.59.2.4.2.962 0 .522-.188.931a1.5 1.5 0 0 1-.521.645q-.34.234-.791.234-.494 0-.891-.287a2 2 0 0 1-.633-.814q-.24-.57-.732-.569a.63.63 0 0 0-.48.206.64.64 0 0 0-.188.433q0 .375.27.879.274.498.925.885.656.386 1.705.386.938 0 1.652-.41.72-.41 1.102-1.107.38-.697.38-1.547 0-.585-.21-1.096a2.7 2.7 0 0 0-.58-.879 2.68 2.68 0 0 0-1.91-.796q-.703 0-1.536.445z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }